<template>
  <CmsSectionShell
    :section-title="sectionTitle"
    :menu-list="list"
    :active-menu-id="activeMenuId"
    :active-menu-name="activeMenuName"
    @home="goHome"
    @section-click="goSectionFirst"
    @menu-click="onMenuClick"
  >
    <template #mobile-content>
      <CmsContentRender
        layout="mobile"
        :content-mode="contentMode"
        :menu-item="currentMenuItem"
        :reload-token="reloadToken"
        :parent-id="parentId"
        :search="search"
        :content-id="inlineArticleId || articleContentId"
        @open-article="onOpenArticle"
        @back-list="onBackList"
      />
    </template>
    <template #pc-content>
      <CmsContentRender
        layout="pc"
        :content-mode="contentMode"
        :menu-item="currentMenuItem"
        :reload-token="reloadToken"
        :parent-id="parentId"
        :search="search"
        :content-id="inlineArticleId || articleContentId"
        @open-article="onOpenArticle"
        @back-list="onBackList"
      />
    </template>
  </CmsSectionShell>
</template>

<script>
import { menu, menuAll } from '@/api/api'
import {
  resolveSubMenuSelection,
  resolveSubMenuRenderMode,
  filterVisibleNavMenus,
} from '@/utils/cmsNav'
import CmsSectionShell from './CmsSectionShell.vue'
import CmsContentRender from './renders/CmsContentRender.vue'

export default {
  name: 'CmsSectionPage',
  components: {
    CmsSectionShell,
    CmsContentRender,
  },
  data() {
    return {
      parentId: this.$route.query.parentId || '',
      sectionTitle: '',
      list: [],
      activeMenuId: '',
      activeMenuIndex: 0,
      reloadToken: 0,
      search: this.$route.query.search || '',
      articleContentId: this.$route.query.contentId || '',
      inlineArticleId: '',
    }
  },
  computed: {
    currentMenuItem() {
      return (this.list || []).find((item) => String(item.menuId) === String(this.activeMenuId)) || null
    },
    activeMenuName() {
      return this.currentMenuItem ? this.currentMenuItem.menuName : ''
    },
    contentMode() {
      if (this.inlineArticleId || this.articleContentId) return 'articleDetail'
      return resolveSubMenuRenderMode(this.currentMenuItem)
    },
  },
  created() {
    this.bootstrap()
    this.$bus.$on('localeChanged', this.bootstrap)
  },
  beforeDestroy() {
    this.$bus.$off('localeChanged', this.bootstrap)
  },
  watch: {
    $route(to) {
      this.parentId = to.query.parentId || ''
      this.search = to.query.search || ''
      this.articleContentId = to.query.contentId || ''
      if (!to.query.contentId) {
        this.inlineArticleId = ''
      }
      if (!this.list.length) {
        this.bootstrap()
        return
      }
      const selection = resolveSubMenuSelection(this.list, to.query)
      if (String(selection.menuId) === String(this.activeMenuId) && !to.query.contentId) {
        return
      }
      this.applySelection(selection, false)
    },
  },
  methods: {
    bootstrap() {
      this.parentId = this.$route.query.parentId || ''
      this.search = this.$route.query.search || ''
      this.articleContentId = this.$route.query.contentId || ''
      menuAll(true).then((navRes) => {
        const section = (navRes.data || []).find((item) => String(item.menuId) === String(this.parentId))
        this.sectionTitle = section ? section.menuName : ''
      })
      menu(this.parentId).then((res) => {
        this.list = filterVisibleNavMenus(res.data || [], this.$i18n.locale)
        const selection = resolveSubMenuSelection(this.list, this.$route.query)
        this.applySelection(selection, false)
      })
    },
    applySelection(selection, reload) {
      this.activeMenuId = selection.menuId
      this.activeMenuIndex = selection.index
      if (reload) {
        this.reloadToken += 1
        this.inlineArticleId = ''
        this.articleContentId = ''
      }
    },
    onMenuClick(index, item) {
      if (!item) return
      const isSame = String(this.activeMenuId) === String(item.menuId)
      this.applySelection({ menuId: item.menuId, index }, true)
      if (!isSame) {
        this.$router.replace({
          path: '/cms',
          query: {
            parentId: this.parentId,
            menuId: item.menuId,
          },
        }).catch(() => {})
      }
    },
    goHome() {
      this.$router.push({ path: '/home', query: { index: 0 } })
    },
    goSectionFirst() {
      if (this.list.length) {
        this.onMenuClick(0, this.list[0])
      }
    },
    onOpenArticle(item) {
      if (!item || !item.id) return
      this.inlineArticleId = item.id
    },
    onBackList() {
      this.inlineArticleId = ''
      this.articleContentId = ''
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/cms/CmsSectionPage.vue